import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { screenCategory } from '../library';

var MobileMenu = /*#__PURE__*/function () {
  function MobileMenu() {
    var menuSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#main-navigation .menu';

    _classCallCheck(this, MobileMenu);

    this.element = document.querySelector(menuSelector);

    if (!!this.element) {
      this.setup();
    } else {
      console.warn('Can not init Mobile Menu script');
    }
  }

  _createClass(MobileMenu, [{
    key: "_closeMenu",
    value: function _closeMenu(item) {
      item.classList.remove('hover'); // Hide children

      var children = item.querySelectorAll('li.hover');

      for (var k = 0; k < children.length; k++) {
        children[k].classList.remove('hover');
      } // Add/remove whole menu class


      if (this.element.querySelectorAll('.menu-item--expanded.hover').length > 0) {
        this.element.classList.add('hover-open');
      } else {
        this.element.classList.remove('hover-open');
      }
    }
  }, {
    key: "_openMenu",
    value: function _openMenu(item, parentUL) {
      // Hide other open menus
      for (var j = 0; j < parentUL.children.length; j++) {
        if (parentUL.children[j] != item) {
          this._closeMenu(parentUL.children[j]);
        }
      } // Trigger hover class


      if (item.classList.contains('hover')) {
        this._closeMenu(item);
      } else {
        item.classList.add('hover');
      }
    }
  }, {
    key: "_eMenu",
    // legacy function Encore
    value: function _eMenu() {
      var _this = this;

      var links = this.element.querySelectorAll('.menu-item--expanded > a .open-below'); // // Exit when blurring menu
      // element.addEventListener('pointerleave', (e) => {
      //   console.log("BLUURRRR");
      //   if(element.classList.contains('hover-open')) {
      //     element.classList.remove('hover-open');
      //     for (let i = 0; i < LINKS.length; i++ ) {
      //       LINKS[i].parentElement.classList.remove('hover');
      //     }
      //   }
      // });
      // for (let i = 0; i < LINKS.length; i++) {
      //   const link = LINKS[i];

      links.forEach(function (link) {
        var item = link.parentElement.parentElement;
        var parentUL = item.parentElement;
        link.addEventListener('click', function (e) {
          e.preventDefault();

          _this._openMenu(item, parentUL);
        });
      }); // const top_menu_items = [...this.element.children].filter((item) => {
      //   return item.classList.contains('menu-item--expanded');
      // });
      // for (let i = 0; i < top_menu_items.length; i++) {
      // top_menu_items.forEach((item) => {
      //   const parentUL = item.parentElement;
      //   item.addEventListener('pointerenter', (e) => {
      //     if(e.pointerType !== 'mouse' || screenCategory() !== 'desktop') return;
      //     e.preventDefault();
      //     this._openMenu(item, parentUL);
      //   });
      //   item.addEventListener('pointerleave', (e) => {
      //     if(e.pointerType !== 'mouse' || screenCategory() !== 'desktop') return;
      //     this._closeMenu(item);
      //   });
      // });
    }
  }, {
    key: "setup",
    value: function setup() {
      //create main navigation menu
      if (!this.element) {
        console.warn('No element found.');
        return;
      }

      this._eMenu();
    }
  }]);

  return MobileMenu;
}();

export { MobileMenu as default };